import React, { useEffect, useState } from "react";
import NavBar from "../../components/NavBar/NavBar";
import SideBar from "../../components/SideBar/SideBar";
import { ToastContainer, toast } from "react-toastify";
import { getConfig, updateConfig } from "../../services/configService";

const SettingsScreen = () => {
  const [data, setData] = useState(null);
  const [updateData, setUpdateData] = useState(null);
  const [promptText, setPromptText] = useState("");

  useEffect(() => {
    const getConfigData = async () => {
      try {
        const res = await getConfig();
        if (res?.status === "success") {
          console.log("Success", res.config);
          setData(res.config);
          if (res.config?.prompt) {
            setPromptText(res.config?.prompt);
          }
        } else throw new Error("Fetching Failed");
      } catch (e) {
        toast(
          e?.response?.data?.message
            ? e?.response?.data?.message
            : "An error occured. Please try again"
        );
      }
    };

    if (data === null) getConfigData();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const updateConfigData = async () => {
      try {
        const res = await updateConfig(updateData);
        if (res?.status === "success") {
          toast("Updated Setting Successfully");
          setUpdateData(null);
        } else throw new Error("Fetching Failed");
      } catch (e) {
        toast(
          e?.response?.data?.message
            ? e?.response?.data?.message
            : "An error occured. Please try again"
        );
      }
    };

    if (updateData !== null) updateConfigData();
  }, [updateData]);

  return (
    <>
      <ToastContainer />
      <NavBar />
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "200px 1fr",
          height: "-webkit-fill-available",
        }}
      >
        <SideBar />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            background: "#fff",
          }}
        >
          <div
            style={{
              padding: "20px 60px",
              display: "flex",
              background: "#F8F8F8",
            }}
          >
            <span
              style={{
                fontSize: "25px",
                fontWeight: "500",
                textAlign: "left",
              }}
            >
              Settings
            </span>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              background: "#fff",
              width: "90%",
              padding: "10px 40px",
            }}
          >
            <div
              style={{
                padding: "15px",
                display: "flex",
                background: "#F5F5F5",
                fontSize: "24px",
                fontWeight: "500",
                textAlign: "left",
                width: "100%",
                borderRadius: "10px",
              }}
            >
              Meeting Settings
            </div>
            <h4 style={{ padding: "15px", fontWeight: "600" }}>
              AUTO DELETE MEETINGS
            </h4>
            <p style={{ padding: "0 15px" }}>
              Set a custom data retention period to automatically delete
              meetings from your notebook. Every meeting will be retained for
              this time period, after which the meeting data will be permanently
              deleted from Scribe.ai
            </p>

            <select
              style={{
                margin: "15px",
                padding: "10px",
                width: "60%",
                outline: "none",
                border: "1px solid #EAECF0",
                background: "#FCFCFD",
                color: "#ADB5BD",
              }}
              onChange={(e) => {
                setUpdateData({ days: e.target.value });
              }}
            >
              <option disabled>Choose Data Retention Period</option>
              <option selected={data?.daysToDelete === "7"} value="7">
                7 Days
              </option>
              <option selected={data?.daysToDelete === "15"} value="15">
                15 Days
              </option>
              <option selected={data?.daysToDelete === "30"} value="30">
                30 Days
              </option>
              <option selected={data?.daysToDelete === "60"} value="60">
                60 Days
              </option>
            </select>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              background: "#fff",
              width: "90%",
              padding: "10px 40px",
            }}
          >
            <div
              style={{
                padding: "15px",
                display: "flex",
                background: "#F5F5F5",
                fontSize: "24px",
                fontWeight: "500",
                textAlign: "left",
                width: "100%",
                borderRadius: "10px",
              }}
            >
              File Upload Settings
            </div>
            <h4 style={{ padding: "15px", fontWeight: "600" }}>
              MAXIMUM FILE UPLOAD SIZE LIMIT
            </h4>
            <p style={{ padding: "0 15px" }}>
              Adjust the maximum size allowed for file uploads. This affects the
              size of files users can upload to the platform.<br></br>
              <b>Note : </b> Increasing the file upload size limit may affect
              performance and storage usage.
            </p>

            <select
              style={{
                margin: "15px",
                padding: "10px",
                width: "60%",
                outline: "none",
                border: "1px solid #EAECF0",
                background: "#FCFCFD",
                color: "#ADB5BD",
              }}
              onChange={(e) => {
                setUpdateData({ size: e.target.value });
              }}
            >
              <option disabled>Choose Maximum File Size</option>
              <option
                selected={data?.maxUploadSize === "104857600"}
                value="104857600"
              >
                100 MB
              </option>
              <option
                selected={data?.maxUploadSize === "209715200"}
                value="209715200"
              >
                200 MB
              </option>
              <option
                selected={data?.maxUploadSize === "314572800"}
                value="314572800"
              >
                300 MB
              </option>
            </select>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              background: "#fff",
              width: "90%",
              padding: "10px 40px",
            }}
          >
            <div
              style={{
                padding: "15px",
                display: "flex",
                background: "#F5F5F5",
                fontSize: "24px",
                fontWeight: "500",
                textAlign: "left",
                width: "100%",
                borderRadius: "10px",
              }}
            >
              Recording Settings
            </div>
            <h4 style={{ padding: "15px", fontWeight: "600" }}>
              AUTO SAVE RECORDINGS
            </h4>
            <p style={{ padding: "0 15px" }}>
              Set a custom retention period to automatically save meetings as
              drafts.
            </p>

            <select
              style={{
                margin: "15px",
                padding: "10px",
                width: "60%",
                outline: "none",
                border: "1px solid #EAECF0",
                background: "#FCFCFD",
                color: "#ADB5BD",
              }}
              onChange={(e) => {
                setUpdateData({ time: e.target.value });
              }}
            >
              <option disabled>Choose Auto Save Time</option>
              <option selected={data?.debounceTime === "2"} value="2">
                2 Minutes
              </option>
              <option selected={data?.debounceTime === "3"} value="3">
                3 Minutes
              </option>
              <option selected={data?.debounceTime === "5"} value="5">
                5 Minutes
              </option>
              <option selected={data?.debounceTime === "10"} value="10">
                10 Minutes
              </option>
            </select>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              background: "#fff",
              width: "90%",
              padding: "10px 40px",
            }}
          >
            <div
              style={{
                padding: "15px",
                display: "flex",
                background: "#F5F5F5",
                fontSize: "24px",
                fontWeight: "500",
                textAlign: "left",
                width: "100%",
                borderRadius: "10px",
              }}
            >
              Prompt
            </div>
            <h4 style={{ padding: "15px", fontWeight: "600" }}>
              Extension Summary Prompt
            </h4>
            <p style={{ padding: "0 15px" }}>
              This Prompt will be Used to generate summary information overe
              extension
            </p>

            <input
              style={{
                margin: "15px",
                padding: "10px",
                width: "60%",
                outline: "none",
                border: "1px solid #EAECF0",
                background: "#FCFCFD",
                color: "#ADB5BD",
              }}
              value={promptText}
              placeholder="Enter your Prompt..."
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  setUpdateData({ prompt: e.target.value });
                }
              }}
              onChange={(e) => {
                setPromptText(e.target.value);
              }}
            ></input>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              background: "#fff",
              width: "90%",
              padding: "10px 40px",
            }}
          >
            <div
              style={{
                padding: "15px",
                display: "flex",
                background: "#F5F5F5",
                fontSize: "24px",
                fontWeight: "500",
                textAlign: "left",
                width: "100%",
                borderRadius: "10px",
              }}
            >
              Token Expiry
            </div>
            <p style={{ padding: "0 15px" }}>
              Set a custom Token Expiry period
            </p>
            <select
              style={{
                margin: "15px",
                padding: "10px",
                width: "60%",
                outline: "none",
                border: "1px solid #EAECF0",
                background: "#FCFCFD",
                color: "#ADB5BD",
              }}
              onChange={(e) => {
                // setUpdateData({ time: e.target.value });
              }}
            >
              <option disabled>Choose Auto Save Time</option>
              <option selected={data?.debounceTime === "2"} value="2">
                2 Minutes
              </option>
              <option selected={data?.debounceTime === "3"} value="3">
                3 Minutes
              </option>
              <option selected={data?.debounceTime === "5"} value="5">
                5 Minutes
              </option>
              <option selected={data?.debounceTime === "10"} value="10">
                10 Minutes
              </option>
            </select>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              background: "#fff",
              width: "90%",
              padding: "10px 40px",
            }}
          >
            <div
              style={{
                padding: "15px",
                display: "flex",
                background: "#F5F5F5",
                fontSize: "24px",
                fontWeight: "500",
                textAlign: "left",
                width: "100%",
                borderRadius: "10px",
              }}
            >
              {" "}
              Inactivity Timeout
            </div>
            <p style={{ padding: "0 15px" }}>
              Set a custom Inactivity Timeout period to automatically logout in
              case of Inactivity
            </p>

            <select
              style={{
                margin: "15px",
                padding: "10px",
                width: "60%",
                outline: "none",
                border: "1px solid #EAECF0",
                background: "#FCFCFD",
                color: "#ADB5BD",
              }}
              onChange={(e) => {
                // setUpdateData({ time: e.target.value });
              }}
            >
              <option disabled>Choose Auto Save Time</option>
              <option selected={data?.debounceTime === "2"} value="2">
                2 Minutes
              </option>
              <option selected={data?.debounceTime === "3"} value="3">
                3 Minutes
              </option>
              <option selected={data?.debounceTime === "5"} value="5">
                5 Minutes
              </option>
              <option selected={data?.debounceTime === "10"} value="10">
                10 Minutes
              </option>
            </select>
          </div>
          {/* <div
            style={{
              display: "flex",
              flexDirection: "column",
              background: "#fff",
              width: "90%",
              padding: "10px 40px",
            }}
          >
            <div
              style={{
                padding: "15px",
                display: "flex",
                background: "#F5F5F5",
                fontSize: "24px",
                fontWeight: "500",
                textAlign: "left",
                width: "100%",
                borderRadius: "10px",
              }}
            >
              TTS Model Selection
            </div>
            <h4 style={{ padding: "15px", fontWeight: "600" }}>
              Select Text to Speech the Model
            </h4>
            <p style={{ padding: "0 15px" }}>
              Using the 'Select Text to Speech' model involves selecting and
              converting text into spoken speech.
            </p>
            <select
              style={{
                margin: "15px",
                padding: "10px",
                width: "60%",
                outline: "none",
                border: "1px solid #EAECF0",
                background: "#FCFCFD",
                color: "#ADB5BD",
              }}
              onChange={(e) => {
                setUpdateData({ tts: e.target.value });
              }}
            >
              <option
                selected={data?.textToSpeech === "Deepgram"}
                value="Deepgram"
              >
                Deepgram
              </option>
              <option selected={data?.textToSpeech === "Custom"} value="Custom">
                Custom TTS
              </option>
            </select>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default SettingsScreen;
